export default "/foods-safety/@slug";
